<template>
  <div id="sub">
    <!-- Mainview Area Start -->
    <div id="mainview">
      <!-- 확장자 확인 필요! -->
      <img src="../assets/images/poster.jpg" alt="메인 이미지">
    </div>
    
    <!-- contents Area Start -->
    <div id="contents">

      <!-- Tab Menu -->
      <div class="tab-menu">
        <ul>
          <!-- 반복문 처리 기능 
            바인드 하려는 대상에 key가 설정되어 있지 않으면 에러가 발생! :
            ':Key'를 추가해서 해결할 것!
            ( , index) 인덱스를 받을 매개변수값을 입력해야 함(v-on="click")이벤트로 전달
          -->
          <li v-for="(tab, index) in tabs" :key="tab">
            <a href="#" v-on:click="currentTab = index" v-bind:class="{act:currentTab === index}">{{ tab }}</a> <!-- 붙혓다 떼는 bind: -->
          </li>
        </ul>
      </div>

      <!-- Tab Content -->
      <div class="tab-contents">
        
      <!-- Tab-content1 -->
      <div class="tab-content tab-content1" 
      v-show="currentTab === 0 "> <!-- 현재 Tab 값이 동일한지 참or거짓 -->
      
        <!-- 영화 소개 -->
        <p>절대적인 전투력을 가진 최고의 영웅! 브루스 웨인(크리스찬 베일)은 복수하고 싶은 욕망은 불타오르지만 명예를 지켜야 한다던 부모님의 가르침 사이에서 갈등하던 그는 홀로 세상을 유랑한다. </p>

        <p>전설이 되기 위해 돌아왔다! 적을 이기려면 적의 세계를 알아야 하는 법! 듀커드는 브루스에게 '어둠의 사도들'에 가입하라는 제안을 한다.....</p>
        
        <!-- 배우 소개 -->
        <div class="act-group">
          <img src="../assets/images/actor1.png" alt="photo1">
          <img src="../assets/images/actor2.png" alt="photo2">
          <img src="../assets/images/actor3.png" alt="photo3">
          <img src="../assets/images/actor4.png" alt="photo4">
          <img src="../assets/images/actor5.png" alt="photo5">
        </div>
      </div>
      
      <!-- Tab-content2 -->
      <div class="tab-content tab-content2" 
        v-show="currentTab === 1"><!-- 조건이 거짓일때 보이지않는 참or거짓 -->
        <iframe width="560" height="315" src="https://www.youtube.com/embed/ty1XzpkAAQA" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
      </div>
      
      <!-- Tab-content3 -->
      <div class="tab-content tab-content3"
      v-show="currentTab === 2">
        <img src="../assets/images/cut-img.jpg" alt="스틸컷 이미지">
      </div>
      
      <!-- Tab-content4 -->
      <div class="tab-content tab-content4"
      v-show="currentTab === 3">
        <p>정의로운 지방 검사 ‘하비 덴트’, ‘짐 고든’ 반장과 함께 범죄 소탕 작전을 펼치며 범죄와 부패로 들끓는 고담시를 지켜나가는 ‘배트맨’ 그러던 어느 날, 살아남기 위해 발버둥치던 범죄 조직은 배트맨을 제거하기 위해 광기어린 악당 ‘조커’를 끌어들이고 정체를 알 수 없는 조커의 등장에 고담시 전체가 깊은 혼돈 속으로 빠져든다.
        </p>
        <p>
        급기야 배트맨을 향한 강한 집착을 드러낸 조커는 그가 시민들 앞에 정체를 밝힐 때까지 매일 새로운 사람들을 죽이겠다 선포하고 배트맨은 사상 최악의 악당 조커를 막기 위해 자신의 모든 것을 내던진 마지막 대결을 준비한다.</p>
        
        <p><a href="#" class="btn btn2">재생하기</a></p>
      
      </div>
    </div>
  </div>

    <!-- Footer Area Start -->
    <AppFooter></AppFooter>

  </div>
</template>

<script>
import AppFooter from './component/Footer.vue'
export default {
  name: "Sub",
  data(){
    // 데이타가 들어있는 변수
    return{
      //초기값은 0으로두고 index값으로 currentTab변수로 click해서 출력
      currentTab: 0, // currentTab = index;
      tabs: ['기본정보','동영상','스틸컷','한줄평']
    }
  },
  components: {
  AppFooter
  },
  mounted(){
    this.linkDefault();
  },
  methods: {
    linkDefault(){
      $('.tab-menu a').click(function(e){
        e.preventDefault();
      });
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../sass/partials/mixin", "../sass/partials/variable";

#sub{
  padding: 0;

  a{ color:#fff; }
  // Mainview Area Start
  #mainview{
    overflow: hidden;
    
    img{ 
      width: 100%; 
      position: relative; top: -200px;
    }

  }
  
  // Contents Area Start
  #contents{
    padding: 0 15px 126px;
    position: relative; top: -150px;
    // Tab-menu 
    .tab-menu{
      height: 42px;
      margin-bottom: 30px;
      
      li{
        height: 42px;
        float: left;
        margin-right: 20px;
        a{
          display: block;
          height: 100%;
          padding: 0 5px;
          color : darken(#fff, 40%);
          position: relative;
          &:hover{ color : #fff; }
          &:hover::after{
            content:'';
            display: block;
            width: 100%;
            height: 3px;
            background-color: #fff;
            position: absolute; left: 0; bottom: 0; 
          }
        }
      }
    }
    // 탭 메뉴 활성화
    .act{
      color: #fff !important;
      &::after{
        content:'';
        display: block;
          width: 100%;
          height: 3px;
          background-color: #fff;
          position: absolute; bottom: 0; 
      }

    }
    
    
    
    // Tab-contents
    .tab-content1{
      p{ padding: 20px 0; }
      .act-group{
        text-align: center;

        img{ margin: 0 5px; display: inline-block;}
      }
    }
    .tab-content2{
      iframe{
        width: 100%;
      }
    }
    .tab-content3{
      img{
        width: 100%;
      }
    }
    .tab-content4{
      p{
        margin-bottom: 21px;
        &:last-child{ margin-top: 30px; }
      }
    }
  }
  }
  



</style>


// WEBPACK FOOTER //
// src/components/Sub.vue